
if (!window.CEARequireSizeSelectionLoaded) {
  window.CEARequireSizeSelectionLoaded = true;

  (() => {
    const PICKER = 'variant-picker[data-main-product="true"]';
    const SIZE = '.variant-picker__product-option[data-size-option="true"]';
    const CART = 'form[action*="/cart/add"] button[type="submit"], .product-form__btn-add-to-cart, .block-add-to-cart__button';
    const EXPRESS = '.product-form__dynamic-checkout, .shopify-payment-button';

    if (!document.getElementById('cea-require-size-selection-styles')) {
      const style = document.createElement('style');
      style.id = 'cea-require-size-selection-styles';

      style.textContent = `
        variant-picker.cea-size-choice-pending ${SIZE} .variant-option.selected + label,
        variant-picker.cea-size-choice-pending ${SIZE} .variant-option:checked + label,
        .cea-width-choice-pending .variant-option.selected + label,
        .cea-width-choice-pending .variant-option:checked + label {
          background: transparent !important;
          background-color: transparent !important;
          color: inherit !important;
          border-color: rgba(var(--color-line-and-border)) !important;
          box-shadow: none !important;
          outline: none !important;
        }

        variant-picker.cea-size-choice-pending ${SIZE} .variant-option.selected + label::before,
        variant-picker.cea-size-choice-pending ${SIZE} .variant-option.selected + label::after,
        variant-picker.cea-size-choice-pending ${SIZE} .variant-option:checked + label::before,
        variant-picker.cea-size-choice-pending ${SIZE} .variant-option:checked + label::after,
        .cea-width-choice-pending .variant-option.selected + label::before,
        .cea-width-choice-pending .variant-option.selected + label::after,
        .cea-width-choice-pending .variant-option:checked + label::before,
        .cea-width-choice-pending .variant-option:checked + label::after {
          opacity: 0 !important;
          box-shadow: none !important;
        }

        .cea-size-gated-control {
          position: relative !important;
        }

        .cea-size-gated-button {
          position: relative !important;
          background: #C5413F !important;
          background-color: #C5413F !important;
          border-color: #C5413F !important;
          color: transparent !important;
          opacity: 1 !important;
        }

        .cea-size-gated-button > *:not(.cea-size-button-label):not(.cea-size-gate-overlay) {
          visibility: hidden !important;
        }

        .cea-size-button-label {
          position: absolute;
          inset: 0;
          z-index: 40;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          padding: inherit;
          color: #fff !important;
          font: inherit;
          font-weight: inherit;
          line-height: inherit;
          letter-spacing: inherit;
          text-align: center;
          pointer-events: none;
          visibility: visible !important;
        }

        .cea-size-gate-overlay {
          position: absolute;
          inset: 0;
          z-index: 50;
          display: block;
          cursor: pointer;
          background: transparent;
          border: 0;
          margin: 0;
          padding: 0;
        }

        .cea-size-choice-required {
          color: #C94444 !important;
        }

        ${SIZE}.cea-size-choice-attention,
        .cea-width-choice-attention {
          animation: cea-size-choice-pulse 0.7s ease-in-out 2;
        }

        @keyframes cea-size-choice-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }

        .cea-price-backup[hidden] {
          display: none !important;
        }

        .product-info__price-wrapper.cea-price-backup-active {
          display: none !important;
        }

        .cea-price-backup .price__content {
          display: flex;
        }
      `;

      document.head.appendChild(style);
    }

    const normalize = value => String(value || '')
      .trim()
      .toLowerCase()
      .replace(/:\s*$/, '')
      .replace(/\s+/g, ' ');

    const valueOf = option =>
      option?.dataset.value || option?.value || '';

    const enabled = option => Boolean(
      option &&
      !option.disabled &&
      !option.classList.contains('disabled') &&
      option.getAttribute('aria-disabled') !== 'true'
    );

    const selected = wrapper =>
      Array.from(wrapper?.querySelectorAll('.variant-option') || [])
        .find(option =>
          enabled(option) &&
          (
            option.classList.contains('selected') ||
            option.getAttribute('aria-selected') === 'true' ||
            (option instanceof HTMLInputElement && option.checked)
          )
        ) || null;

    const widthWrapper = picker =>
      Array.from(
        picker.querySelectorAll('.variant-option[data-option-name]')
      )
        .find(option =>
          normalize(option.dataset.optionName) === 'width'
        )
        ?.closest('.variant-picker__product-option') || null;

    const heading = wrapper =>
      wrapper?.closest('fieldset.variant-option__wrapper')
        ?.querySelector('.variant-option__selected-value') || null;

    const setHeading = (wrapper, text) => {
      const node = heading(wrapper);
      if (node && node.textContent !== text) {
        node.textContent = text;
      }
    };

    function clickedOption(event, picker) {
      const direct = event.target.closest?.('.variant-option');

      if (direct && picker.contains(direct)) return direct;

      const label = event.target.closest?.('label[for]');

      if (!label || !picker.contains(label)) return null;

      try {
        return picker.querySelector(
          `#${CSS.escape(label.getAttribute('for'))}`
        );
      } catch (_) {
        return null;
      }
    }

    function availableWidths(wrapper) {
      return Array.from(
        wrapper?.querySelectorAll('.variant-option') || []
      ).filter(option => {
        if (
          !enabled(option) ||
          normalize(option.dataset.optionName) !== 'width'
        ) {
          return false;
        }

        let label = option.nextElementSibling?.matches('label')
          ? option.nextElementSibling
          : null;

        if (!label && option.id) {
          try {
            label = option.closest('fieldset')?.querySelector(
              `label[for="${CSS.escape(option.id)}"]`
            );
          } catch (_) {
            return false;
          }
        }

        if (!label || !label.getClientRects().length) {
          return false;
        }

        const css = getComputedStyle(label);

        return css.display !== 'none' &&
          css.visibility !== 'hidden';
      });
    }

    function initialize(picker) {
      if (picker.dataset.ceaSizeGateInitialized === 'true') {
        return;
      }

      const sizeWrapper = picker.querySelector(SIZE);

      const sizePosition = sizeWrapper
        ?.querySelector('.variant-option[data-option-position]')
        ?.dataset.optionPosition;

      if (!sizeWrapper || !sizePosition) return;

      picker.dataset.ceaSizeGateInitialized = 'true';
      picker.dataset.ceaSizeChosen = 'false';
      picker.dataset.ceaWidthChosen = 'false';

      const section =
        document.getElementById(
          `shopify-section-${picker.dataset.sectionId}`
        ) ||
        picker.closest('.shopify-section') ||
        document;

      const initialVariant =
        new URLSearchParams(location.search).get('variant');

      const canRestore = Boolean(
        widthWrapper(picker) &&
        /^\d+$/.test(initialVariant || '')
      );

      const price =
        section.querySelector(
          '.product-info__price-wrapper[data-block-id="price"]'
        ) ||
        section.querySelector('.product-info__price-wrapper');

      let interacted = false;
      let finished = false;
      let checkQueued = false;

      // Only manual width choices update this preference.
      let preferredWidth = null;

      let sizeToken = 0;
      let pendingSize = '';
      let syntheticWidthClick = false;
      let widthRevision = 0;

      let lastAutoClick = {
        token: -1,
        width: '',
        at: 0
      };

      let priceBackup = null;
      let savedPrice = null;
      let lastValidPriceHeight = 0;
      let priceQueued = false;

      function needed() {
        if (finished) return '';

        if (picker.dataset.ceaSizeChosen !== 'true') {
          return 'size';
        }

        if (
          widthWrapper(picker) &&
          picker.dataset.ceaWidthChosen !== 'true'
        ) {
          return 'width';
        }

        return '';
      }

      function restoreHeading(wrapper) {
        const option = selected(wrapper);
        if (!option) return;

        if (valueOf(option) && valueOf(option) !== 'on') {
          setHeading(wrapper, valueOf(option));
        }

        heading(wrapper)?.classList.remove(
          'cea-size-choice-required'
        );
      }

      // Preserve price and Shop Pay spacing.
      function snapshotPrice() {
        if (
          !price ||
          price.classList.contains('is-unavailable')
        ) {
          return;
        }

        const height = price.getBoundingClientRect().height;

        if (height > 0) {
          lastValidPriceHeight = height;
        }

        const content = price.querySelector('.price__container');

        if (
          !content
            ?.querySelector('.main-price .money')
            ?.textContent.trim()
        ) {
          return;
        }

        const fragment = document.createDocumentFragment();
        const clone = content.cloneNode(true);

        clone.querySelectorAll('[id]').forEach(node => {
          node.removeAttribute('id');
        });

        fragment.appendChild(clone);

        const terms = price.querySelector(
          'shopify-payment-terms'
        );

        if (terms) {
          const copy = terms.cloneNode(true);
          copy.removeAttribute('id');

          const reserve = document.createElement('div');
          reserve.className = 'cea-payment-terms-reserve';
          reserve.appendChild(copy);

          fragment.appendChild(reserve);
        }

        savedPrice = fragment;
      }

      function syncPrice() {
        if (!price?.isConnected) return;

        const backupNeeded =
          price.classList.contains('is-unavailable') &&
          savedPrice &&
          (
            needed() === 'width' ||
            (priceBackup && !priceBackup.hidden)
          );

        if (backupNeeded) {
          if (!priceBackup) {
            priceBackup = document.createElement('div');

            priceBackup.className = price.className
              .replace(
                /\bis-unavailable\b|\bcea-price-backup-active\b/g,
                ''
              )
              .trim() + ' cea-price-backup';

            priceBackup.setAttribute(
              'aria-label',
              'Price before width selection'
            );

            price.insertAdjacentElement(
              'afterend',
              priceBackup
            );
          }

          if (!priceBackup.hasChildNodes()) {
            priceBackup.appendChild(
              savedPrice.cloneNode(true)
            );
          }

          priceBackup.hidden = false;

          if (lastValidPriceHeight > 0) {
            priceBackup.style.minHeight =
              `${lastValidPriceHeight}px`;
          }

          price.classList.add('cea-price-backup-active');
        } else {
          price.classList.remove('cea-price-backup-active');

          if (priceBackup) {
            priceBackup.hidden = true;
            priceBackup.replaceChildren();
          }

          snapshotPrice();
        }
      }

      function queuePrice() {
        if (priceQueued) return;

        priceQueued = true;

        requestAnimationFrame(() => {
          priceQueued = false;
          syncPrice();
        });
      }

      if (price) {
        snapshotPrice();

        new MutationObserver(queuePrice).observe(price, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }

      function removeGate() {
        section.querySelectorAll(
          '.cea-size-gate-overlay, .cea-size-button-label'
        ).forEach(element => element.remove());

        section.querySelectorAll(
          '.cea-size-gated-button'
        ).forEach(element => {
          element.classList.remove('cea-size-gated-button');
        });

        section.querySelectorAll(
          '.cea-size-gated-control'
        ).forEach(element => {
          element.classList.remove('cea-size-gated-control');
        });
      }

      function finish(restored = false) {
        if (finished) return;

        finished = true;

        picker.dataset.ceaSizeChosen = 'true';

        if (widthWrapper(picker)) {
          picker.dataset.ceaWidthChosen = 'true';
        }

        picker.classList.remove('cea-size-choice-pending');

        widthWrapper(picker)?.classList.remove(
          'cea-width-choice-pending'
        );

        clearTimeout(picker.ceaSizePromptTimer);

        sizeWrapper.classList.remove(
          'cea-size-choice-attention'
        );

        widthWrapper(picker)?.classList.remove(
          'cea-width-choice-attention'
        );

        removeGate();

        if (restored) {
          restoreHeading(sizeWrapper);
          restoreHeading(widthWrapper(picker));
        }

        observer.disconnect();
        queuePrice();
      }

      function tryRestore() {
        if (
          !canRestore ||
          interacted ||
          finished ||
          new URLSearchParams(location.search).get('variant') !==
            initialVariant
        ) {
          return false;
        }

        const width = widthWrapper(picker);

        if (
          !width ||
          !selected(sizeWrapper) ||
          !selected(width)
        ) {
          return false;
        }

        const cartId = section.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );

        if (
          !cartId ||
          cartId.value !== initialVariant
        ) {
          return false;
        }

        if (
          picker.dataset.currentVariantId &&
          picker.dataset.currentVariantId !== initialVariant
        ) {
          return false;
        }

        preferredWidth = valueOf(selected(width));

        finish(true);
        return true;
      }

      function prompt() {
        const missing = needed();
        if (!missing) return;

        const wrapper = missing === 'size'
          ? sizeWrapper
          : widthWrapper(picker);

        if (!wrapper) return;

        setHeading(
          wrapper,
          missing === 'size'
            ? 'Please choose a size'
            : 'Please choose a width'
        );

        heading(wrapper)?.classList.add(
          'cea-size-choice-required'
        );

        wrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        wrapper.classList.remove(
          'cea-size-choice-attention',
          'cea-width-choice-attention'
        );

        void wrapper.offsetWidth;

        wrapper.classList.add(
          missing === 'size'
            ? 'cea-size-choice-attention'
            : 'cea-width-choice-attention'
        );

        clearTimeout(picker.ceaSizePromptTimer);

        picker.ceaSizePromptTimer = setTimeout(() => {
          if (needed() !== missing) return;

          setHeading(
            wrapper,
            missing === 'size'
              ? 'Choose a size'
              : 'Choose a width'
          );

          heading(wrapper)?.classList.remove(
            'cea-size-choice-required'
          );

          wrapper.classList.remove(
            'cea-size-choice-attention',
            'cea-width-choice-attention'
          );
        }, 2200);
      }

      function overlay(control) {
        control.classList.add('cea-size-gated-control');

        if (control.matches(CART)) {
          control.classList.add('cea-size-gated-button');

          let label = control.querySelector(
            ':scope > .cea-size-button-label'
          );

          if (!label) {
            label = document.createElement('span');
            label.className = 'cea-size-button-label';
            label.setAttribute('aria-hidden', 'true');
            control.appendChild(label);
          }

          const text = needed() === 'width'
            ? 'Choose Width'
            : 'Choose Size';

          if (label.textContent !== text) {
            label.textContent = text;
          }
        }

        if (
          control.querySelector(
            ':scope > .cea-size-gate-overlay'
          )
        ) {
          return;
        }

        const layer = document.createElement('span');
        layer.className = 'cea-size-gate-overlay';
        layer.setAttribute('aria-hidden', 'true');

        layer.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          prompt();
        });

        layer.addEventListener('pointerdown', event => {
          event.preventDefault();
          event.stopPropagation();
        });

        control.appendChild(layer);
      }

      function applyPending() {
        if (finished || tryRestore()) return;

        if (needed() === 'size') {
          picker.classList.add('cea-size-choice-pending');
          setHeading(sizeWrapper, 'Choose a size');
        } else if (needed() === 'width') {
          picker.classList.remove('cea-size-choice-pending');

          const wrapper = widthWrapper(picker);

          wrapper?.classList.add(
            'cea-width-choice-pending'
          );

        } else {
          return;
        }

        section.querySelectorAll(CART).forEach(overlay);
        section.querySelectorAll(EXPRESS).forEach(overlay);

        queuePrice();
      }

      function queueCheck() {
        if (finished || checkQueued) return;

        checkQueued = true;

        requestAnimationFrame(() => {
          checkQueued = false;
          applyPending();
        });
      }

      // Confirm the correct width after Swift updates.
      function confirmWidth(token, size, widthValue) {
        if (
          finished ||
          token !== sizeToken ||
          needed() !== 'width'
        ) {
          return;
        }

        if (valueOf(selected(sizeWrapper)) !== size) {
          return;
        }

        const wrapper = widthWrapper(picker);

        const option = availableWidths(wrapper).find(
          item => valueOf(item) === widthValue
        );

        if (
          !option ||
          selected(wrapper) !== option ||
          price?.classList.contains('is-unavailable')
        ) {
          return;
        }

        restoreHeading(wrapper);
        finish();
      }

      function resolveWidth(token, size) {
        if (
          finished ||
          token !== sizeToken ||
          needed() !== 'width'
        ) {
          return;
        }

        if (valueOf(selected(sizeWrapper)) !== size) {
          return;
        }

        const wrapper = widthWrapper(picker);
        const choices = availableWidths(wrapper);

        // A single available width takes priority.
        // Otherwise restore the customer's manual preference.
        const target = choices.length === 1
          ? choices[0]
          : choices.find(
              option =>
                preferredWidth &&
                valueOf(option) === preferredWidth
            );

       if (!target) {
  return;
}

        const targetValue = valueOf(target);

        if (
          selected(wrapper) === target &&
          !price?.classList.contains('is-unavailable')
        ) {
          requestAnimationFrame(() => {
            confirmWidth(token, size, targetValue);
          });
          return;
        }

        // Prevent duplicate clicks while Swift is updating.
        const now = Date.now();

        if (
          lastAutoClick.token === token &&
          lastAutoClick.width === targetValue &&
          now - lastAutoClick.at < 240
        ) {
          return;
        }

        lastAutoClick = {
          token,
          width: targetValue,
          at: now
        };

        const wasChecked =
          target instanceof HTMLInputElement &&
          target.checked;

        syntheticWidthClick = true;

        try {
          target.click();

          if (wasChecked) {
            target.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          }
        } finally {
          syntheticWidthClick = false;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            confirmWidth(token, size, targetValue);
          });
        });
      }

      // Check after Swift's DOM changes, not after a fixed delay.
      function queueWidthResolution() {
        if (
          finished ||
          needed() !== 'width'
        ) {
          return;
        }

        const revision = ++widthRevision;
        const token = sizeToken;
        const size = pendingSize;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (
              revision !== widthRevision ||
              token !== sizeToken ||
              finished
            ) {
              return;
            }

            resolveWidth(token, size);
          });
        });
      }

      function observe() {
        observer.observe(section, {
          subtree: true,
          childList: true
        });

        observer.observe(picker, {
          subtree: true,
          attributes: true,
          attributeFilter: [
            'class',
            'disabled',
            'aria-disabled',
            'aria-selected',
            'checked',
            'style',
            'hidden',
            'data-current-variant-id'
          ]
        });
      }

      function onSize(sizeOption) {
        const wrapper = widthWrapper(picker);
        if (!wrapper) return;

        interacted = true;

        picker.dataset.ceaSizeChosen = 'true';
        picker.dataset.ceaWidthChosen = 'false';

        picker.classList.remove('cea-size-choice-pending');

        clearTimeout(picker.ceaSizePromptTimer);
        clearTimeout(picker.ceaWidthPromptTimer);

        sizeWrapper.classList.remove(
          'cea-size-choice-attention'
        );

        wrapper.classList.remove(
          'cea-width-choice-attention'
        );

        if (finished) {
          finished = false;
          observe();
        }

       wrapper.classList.add('cea-width-choice-pending');

clearTimeout(picker.ceaWidthPromptTimer);

picker.ceaWidthPromptTimer = setTimeout(() => {
  if (!finished && needed() === 'width') {
    setHeading(wrapper, 'Choose a width');
  }
}, 1400);

        pendingSize = valueOf(sizeOption);

        ++sizeToken;
        ++widthRevision;

        applyPending();
        queueCheck();
        queueWidthResolution();

      // Retry the actual width selection until Swift is ready.
[450, 800, 1200, 1800].forEach(delay => {
  const token = sizeToken;
  const size = pendingSize;

  setTimeout(() => {
    if (token !== sizeToken || finished) return;

    resolveWidth(token, size);
  }, delay);
});
      }

      picker.addEventListener('click', event => {
        const option = clickedOption(event, picker);

        if (!enabled(option)) return;

        const isSize =
          sizeWrapper.contains(option) &&
          option.dataset.optionPosition === sizePosition;

        if (isSize) {
          interacted = true;

          if (widthWrapper(picker)) {
            onSize(option);
          } else if (!finished) {
            picker.dataset.ceaSizeChosen = 'true';
            finish();
          }

          return;
        }

        if (
          normalize(option.dataset.optionName) === 'width' &&
          widthWrapper(picker)?.contains(option) &&
          !syntheticWidthClick
        ) {
          preferredWidth = valueOf(option);
          interacted = true;

          ++sizeToken;
          ++widthRevision;

          if (!finished && needed() === 'width') {
            finish();
          }
        }
      }, true);

      const observer = new MutationObserver(mutations => {
        if (finished) return;

        queueCheck();

        if (needed() !== 'width') return;

        const width = widthWrapper(picker);

        const changed = mutations.some(mutation => {
          const target = mutation.target;

          if (!(target instanceof Element)) {
            return false;
          }

          if (
            width &&
            (target === width || width.contains(target))
          ) {
            return true;
          }

          return mutation.type === 'childList' &&
            picker.contains(target);
        });

        if (changed) {
          queueWidthResolution();
        }
      });

      observe();
      applyPending();

      requestAnimationFrame(() => {
        applyPending();
        requestAnimationFrame(applyPending);
      });

      if (canRestore) {
        setTimeout(tryRestore, 250);
        setTimeout(tryRestore, 1000);
      }
    }

    function initializeAll(root = document) {
      if (
        root instanceof Element &&
        root.matches(PICKER)
      ) {
        initialize(root);
      }

      root.querySelectorAll?.(PICKER).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeAll(),
        { once: true }
      );
    } else {
      initializeAll();
    }

    document.addEventListener(
      'shopify:section:load',
      event => initializeAll(event.target)
    );

    new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            initializeAll(node);
          }
        }
      }
    }).observe(document.documentElement, {
      subtree: true,
      childList: true
    });
  })();
}
